import playerStore from "lib/player_store";
import { goog_report_conversion, call_bing_song3 } from "./ad_conversions.js";
import { getJSON } from "./ajax";

import history from "lib/history";

export function tunein(
  station_id = null,
  song_id = null,
  artist_name = null,
  radio_song_id = null,
  tune_in_without_skip = null
  // nav = true
) {
  console.log(
    "tunein",
    station_id,
    song_id,
    artist_name,
    radio_song_id,
    tune_in_without_skip
  );

  let endp;

  if (radio_song_id) {
    playerStore.setFreakingOut(false);
    playerStore.set_working(true);
    endp = `/stations/song_radio_tunein/play?radio_song_id=${radio_song_id}`;
  } else if (tune_in_without_skip) {
    playerStore.setFreakingOut(false);
    playerStore.set_working(true);
    endp = `/stations/${station_id}/play?tiwos=1`;
  } else {
    playerStore.handleRegularTuneIn();
    //    playerStore.setPlayerStopTrigger();
    // playerStore.setFreakingOut(false);

    // playerStore.set_loading(true);
    // if (playerStore.working) {
    //   return false;
    // }
    // playerStore.set_working(true);
    // playerStore.set_songTime(0);
    // playerStore.setDuration(0);

    // song_id indicates airplay song tunein likely from band_show
    if (artist_name) {
      endp = `/stations/exclusive_tunein/play?artist=${artist_name}`;
    } else if (song_id) {
      endp = `/stations/airplay_song_tunein/play?song_id=${song_id}`;
    } else {
      endp = `/stations/${station_id}/play`;
    }
  }
  getJSON({ url: endp })
    .then((data) => {
      if (!updateData(data)) {
        return;
      }
      if (document.location.pathname != "/") {
        //  Turbolinks.visit("/");
        history.push("/");
      }
    })
    .catch((e) => {
      console.log("ERROR", e);
      updateData({ message: "station_error" });
    });

  return true;
}

function updateData(data, url_only) {
 // console.log("updatedata", data);
  //  this.removeStale();
  if (data.ver) {
    _jango.check_client_ver(data.ver);
  }

  if (!usd_HandleMessage(data)) {
    //console.log("updateData", "returning");
    return false;
  }

  // dont ping play event if tunein_without_skip
  if (data.tunein_without_skip != 1) {
    usd_GA(data);

    if (parseInt(data.session_plays) > 1) {
      _jm.session_plays = data.session_plays;
    } else {
      _jm.session_plays = 1;
    }
  }

  if (url_only || data.tunein_without_skip) {
    if (data.mdc) {
      const m = data.mdc;
      delete data.mdc;
      playerStore.set_mdc(m);
    }
    if (data.mdc100) {
      const m100 = data.mdc100;
      delete data.mdc100;
      playerStore.set_mdc100(m100);
    }
    playerStore.merge(data);
  } else {
    playerStore.update(data);
  }

  if (data.monetized == true) {
    playerStore.get_airplay_overlay();
  } else {
    playerStore.closeAirplayOverlay();
  }

  usd_HandleConversions(data);

  document.title = playerStore.docTitle;

  playerStore.set_working(false);
  playerStore.set_loading(false);
  playerStore.set_firstLoad(false);
  // keep
  return true;
}

export function usd(url_only) {
  if (playerStore.working) {
    return false;
  }
  playerStore.set_loading(true);

  playerStore.set_working(true);
  // playerStore.set_songTime(0);
  // playerStore.setDuration(0);

  let params = getUSDParams();
  if (url_only) {
    params.url_only = url_only;
  }

  //  playerStore.set_loading(!playerStore.firstLoad);

  // clear airplay promo overlay if present

  getJSON({ url: "/streams/info", data: params })
    .then((data) => {
     // console.log("data, url_only", data, url_only);

      updateData(data, url_only);
    })
    .catch((e) => {
      //      window.PlayerUI?.setVisible(false);
      console.log("usd error", e);
      playerStore.set_loading(false);
      playerStore.merge({
        song: "Oops. Off The Air",
        artist: "",
        album: "",
        video_id: null,
      });
      playerStore.set_songTime(0);
      playerStore.set_autoplayOverlay("closed");
      playerStore.setFreakingOut(true);
    })
    .finally(() => {
      playerStore.set_working(false);
    });
}

function getUSDParams() {
  let params = {};

  const { firstLoad, user_id, shuffle, songInfo, signUpOpen } = playerStore;

  if (firstLoad) {
    params.first_time = 1;
  }
  if (_jm.session_id) {
    params.sid = _jm.session_id;
  }
  if (user_id) {
    params.uid = user_id;
  }
  if (_jm.station_id) {
    params.stid = _jm.station_id;
  }
  if (top.ver) {
    params.ver = top.ver;
  }
  if (shuffle) {
    params.shufflin = 1;
  }

  try {
    if (user_id === 0 && signUpOpen) {
      params.suw = 1;
    }
  } catch (e) {}

  if (_jm.skipped) {
    params.skipped = 1;
    params.clicked = _jm.clicked ? 1 : 0;

    const { monetized, airplay_song_id, song_id, artist_id } = songInfo;

    params.mo = monetized;
    params.as = airplay_song_id;
    params.so = song_id;
    params.ar = artist_id;

    if (_jm.offset) {
      params.offset = parseInt(_jm.offset);
      _jm.offset = null;
    }
  }
  if (_jm.next) {
    params.next = 1;
  }

  params.cb = new Date().getTime();
  //  console.log("usd params", params);
  return params;
}

function usd_HandleMessage(data) {
  console.log("usd_HandleMessage", data.message);
  if (!data.message) {
    return true;
  }
  let returnValue = true;

  switch (data.message) {
    case "station_error":
      playerStore.setPaused(true);
      playerStore.set_loading(false);
      playerStore.set_working(false);
      try {
        //  urchinTracker("error_station");
        //window.ga("send", "event", "player", "error", "station");
        window.gtag("event", "error", {
          event_category: "player",
          event_label: "station",
        });
      } catch (e) {}
      playerStore.setStationError(true);

      returnValue = false;
      break;

    case "stream_error":
      playerStore.setPaused(true);
      playerStore.set_loading(false);
      playerStore.set_working(false);
      try {
        //  urchinTracker("error_stream");
        // window.ga("send", "event", "player", "error", "stream");
        window.gtag("event", "error", {
          event_category: "player",
          event_label: "stream",
        });
      } catch (e) {}
      playerStore.setStationError(true);

      returnValue = false;
      break;

    case "too_many_skips":
      playerStore.set_working(false);
      playerStore.set_loading(false);
      playerStore.setPaused(true);
      playerStore.setTooManySkipsMessageOpen(true);

      playerStore.update(data);
      // window.audioPlayer.seek(data.offset);
      // eeeewwww
      try {
        console.log("re seek skip denied", data.offset);
        window.Howler._howls[0].seek(data.offset);
      } catch (e) {
        console.log(e);
      }
      // soundManager.play(ctrls.currentSongID, { position: data.offset * 1000 });
      playerStore.setPaused(false);

      try {
        window.gtag("event", "error", {
          event_category: "player",
          event_label: "denied",
        });

        // window.ga("send", "event", "player", "error", "denied");
      } catch (e) {}
      returnValue = false;
      break;
  }

  return returnValue;
}

function usd_HandleConversions(data) {
  if (data.session_plays == 3) {
    goog_report_conversion("song3");
    call_bing_song3();
  }
}

function usd_GA(data) {
  if (data.session_plays <= 3) {
    try {
      // window.ga("send", "event", "play", "number", data.session_plays);
      window.gtag("event", "number", {
        event_category: "play",
        event_label: data.session_plays,
      });
    } catch (e) {}
  }
  // const aid =
  //   typeof data.artist_id === "undefined"
  //     ? this.store.songInfo.artist_id
  //     : data.artist_id;
  // const sid =
  //   typeof data.song_id === "undefined"
  //     ? this.store.songInfo.song_id
  //     : data.song_id;
  if (typeof data.band_id !== "undefined" && data.band_id != null) {
    if (typeof data.monetized !== "undefined" && data.monetized == true) {
      try {
        // urchinTracker(`airplaymon_${aid}_${sid}`);
        //    window.ga("send", "event", "audio", "airplay", "monetized");
        window.gtag("event", "airplay", {
          event_category: "audio",
          event_label: "monetized",
        });

        window.fbq("track", "Purchase", {
          content_ids: [data.artist_id],
          artist: data.artist,
        });
      } catch (e) {}
    } else {
      try {
        // urchinTracker(`airplay_${aid}_${sid}`);
        // window.ga("send", "event", "audio", "airplay", "organic");
        window.gtag("event", "airplay", {
          event_category: "audio",
          event_label: "organic",
        });

        window.fbq("track", "ViewContent", {
          artist: data.artist,
        });
      } catch (e) {}
    }
  } else {
    try {
      // urchinTracker(`stream_${aid}_${sid}`);
      console.log("calling ga play");
      // window.ga("send", "event", "audio", "play", "established", {
      //   hitCallback: function () {
      //     //   console.log("ga", "send", "event", "audio", "play", "established");
      //   },
      // });

      window.gtag("event", "play", {
        event_category: "audio",
        event_label: "established",
      });

      window.fbq("track", "ViewContent", {
        artist: data.artist || playerStore.songInfo?.artist,
      });
    } catch (e) {
      console.log("player ga player error:", e);
    }
    try {
      if (!playerStore.songInfo.allow_explicit) {
        // urchinTracker("play_with_explicit_filter");
        // window.ga("send", "event", "audio", "play", "with_explicit_filter");
        window.gtag("event", "play", {
          event_category: "audio",
          event_label: "with_explicit_filter",
        });
      }
    } catch (e) {}
  }
}

// export function setupPlayerLinks() {
//   addDocEvent("click", "a[target=player]", (event) => {
//     console.log("got click on:", event);
//     var hr = $(event.currentTarget).attr("href");
//     // console.log("hr:" + hr);
//     var station_id;
//     var song_id;
//     var artist_name;

//     if (hr.match(/airplay_song_tunein/)) {
//       if (hr.split("?")[1].match(/song_id/)) {
//         var qstr = hr.split("?")[1];
//         station_id = "airplay_song_tunein";
//         song_id = parseInt(qstr.split("=")[qstr.split("=").length - 1]);
//       }
//     } else if (hr.match(/exclusive_tunein/)) {
//       station_id = "exclusive_tunein";
//       var a = hr.split("/");
//       var artist_name = a[a.length - 2];
//     } else if (hr.match(/tunein|play/)) {
//       var a = hr.split("/");
//       var station_id = parseInt(a[a.length - 2]);
//     }

// console.log(
//   "tunein: station_id:" +
//     station_id +
//     " song_id:" +
//     song_id +
//     " artist:" +
//     artist_name
// );

//     tunein(station_id, song_id, artist_name);
//     event.preventDefault();
//     return false;
//   });
// }

export function addDocEvent(event_name, selector, callback) {
  const names = Array.isArray(event_name) ? event_name : Array(event_name);

  if (typeof selector === "function") {
    callback = selector;
    selector = null;
  }

  names.forEach((n) => {
    document.addEventListener(
      n,
      (e) => {
        if (!selector) {
          console.log("do callback - no selector");

          callback(e);
        } else if (e.target.matches(selector)) {
          console.log("do callback - selector");
          callback(e);
        }
      },
      false
    );
  });
}
